import LoadingButton from "components/Common/LoadingButton"
import InputRHF from "components/RHF/InputRHF"
import { t } from "i18next"
import React from "react"
import { useFieldArray, useForm } from "react-hook-form"
import { Button } from "reactstrap"

function EditFieldsForm({ fields = [], onSubmit }) {
  const { handleSubmit, control, formState } = useForm({
    defaultValues: {
      fields,
    },
  })

  const { fields: fieldsArray } = useFieldArray({
    control,
    name: `fields`,
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {fieldsArray.map((field, idx) => {
        return (
          <InputRHF
            label={field.name}
            name={`fields.${idx}.value`}
            key={field.id}
            control={control}
          />
        )
      })}
      <LoadingButton isLoading={formState.isSubmitting} type="submit">
        {t("save")}
      </LoadingButton>
    </form>
  )
}

export default EditFieldsForm
